import { Box, Button } from "@material-ui/core";
import React from "react";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { addFormField } from "redux/actions/FormBuilder";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { dateFormat } from "@jumbo/utils/shamsiStandardFormat";
import CallIcon from "@material-ui/icons/Call";
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import TitleIcon from "@material-ui/icons/Title";

const useStyles = makeStyles((_) => ({
  fieldButton: {
    width: "100%",
    marginBottom: "16px",
  },
}));

const Fields = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const generateUniqueId = () => {
    return (
      Date.now().toString(36) +
      Math.random()
        .toString(36)
        .substr(2, 9)
    );
  };

  const handleAddFiled = (type) => {
    let defaultField;
    if (type === "Text") {
      defaultField = {
        id: generateUniqueId(),
        type: type,
        title: "",
        subtitle: "",
        desc: "",
      };
    } else {
      defaultField = {
        id: generateUniqueId(),
        type: type,
        title: "",
        subtitle: "",
        desc: "",
        placeHolder: "",
        required: false,
        visibilityCondition: false,
        visibilityConditionSource: "",
        visibilityConditionValue: "",
        examQuestion: false,
      };
    }
    if (
      type === "Textfield" ||
      type === "TextArea" ||
      type === "Number" ||
      type === "Phone"
    ) {
      defaultField["placeHolder"] = "";
    }
    if (type === "CheckBox" || type === "RadioButton") {
      defaultField["selectionList"] = [
        {
          title: "گزینه اول",
          id: generateUniqueId(),
          limits: {
            date: false,
            startDate: dateFormat,
            endDate: dateFormat,
            count: false,
            countLimit: 0,
          },
          markAsAttended: false,
        },
        {
          title: "گزینه دوم",
          id: generateUniqueId(),
          limits: {
            date: false,
            startDate: dateFormat,
            endDate: dateFormat,
            count: false,
            countLimit: 0,
          },
          markAsAttended: false,
        },
        {
          title: "گزینه سوم",
          id: generateUniqueId(),
          limits: {
            date: false,
            startDate: dateFormat,
            endDate: dateFormat,
            count: false,
            countLimit: 0,
          },
          markAsAttended: false,
        },
        {
          title: "گزینه چهارم",
          id: generateUniqueId(),
          limits: {
            date: false,
            startDate: dateFormat,
            endDate: dateFormat,
            count: false,
            countLimit: 0,
          },
          markAsAttended: false,
        },
      ];
      if (type === "RadioButton") {
        defaultField["examQuestionHasRightAnswer"] = false;
        defaultField["examQuestionRightAnswer"] = "";
      }
    }
    if (type === "File") {
      defaultField["fileType"] = "all";
    }
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
    dispatch(addFormField(defaultField));
  };

  return (
    <Box width={"100%"}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<TextFieldsIcon />}
        className={classes.fieldButton}
        onClick={() => handleAddFiled("Textfield")}
      >
        متن تک خطی
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<TextFieldsIcon />}
        className={classes.fieldButton}
        onClick={() => handleAddFiled("TextArea")}
      >
        متن چند خطی
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<FormatListNumberedIcon />}
        className={classes.fieldButton}
        onClick={() => handleAddFiled("Number")}
      >
        عدد
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<CallIcon />}
        className={classes.fieldButton}
        onClick={() => handleAddFiled("Phone")}
      >
        شماره تلفن
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<CheckBoxIcon />}
        className={classes.fieldButton}
        onClick={() => handleAddFiled("CheckBox")}
      >
        چک باکس
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<RadioButtonCheckedIcon />}
        className={classes.fieldButton}
        onClick={() => handleAddFiled("RadioButton")}
      >
        چند گزینه‌ای
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<CloudUploadIcon />}
        className={classes.fieldButton}
        onClick={() => handleAddFiled("File")}
      >
        آپلود فایل
      </Button>
      <hr />
      <br />
      <Button
        variant="contained"
        color="primary"
        startIcon={<TitleIcon />}
        className={classes.fieldButton}
        onClick={() => handleAddFiled("Text")}
      >
        عنوان
      </Button>
    </Box>
  );
};

export default Fields;
